<template>
  <el-drawer :visible.sync="drawer" :with-header="false" size="700px" @close="close">
    <div class="join-inquiry-list-drawer">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="onClose"></i>
      </div>
      <!-- 物流入库-->
      <div class="item-box-add" style="margin-bottom:0;padding-top:30px;">
        <el-table
          border
          ref="tableRef"
          tooltip-effect="dark"
          :data="list"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="品牌" prop="brandName" show-overflow-tooltip></el-table-column>
          <el-table-column label="产品名称" prop="proName" show-overflow-tooltip></el-table-column>
          <el-table-column label="型号">
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="detailModel(scope.row)"
              >{{ scope.row.proModel }}</div>
            </template>
          </el-table-column>
          <el-table-column label="订货号" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.proOrderNum }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="invoiceState" label="收票状态"></el-table-column>
          <el-table-column prop="deliverState" label="发货状态"></el-table-column>
          <el-table-column label="数量">
            <template slot-scope="scope">
              <div>{{ scope.row.retreatCount }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 产品序列号 -->
      <div class="item-box-add" style="margin-top:20px">
        <el-row style="margin-bottom:20px;margin-top:30px;">
          <el-col :span="24">
            <div class="grid-content bg-purple-dark">
              <span class="basic title-font-style">产品序列号</span>
            </div>
          </el-col>
        </el-row>
        <el-form>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <el-input v-model="number" placeholder="请输入产品序列号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width="0px" style="text-align:left;">
                <el-button type="primary" @click="onSearch">搜索</el-button>
                <el-button @click="onRefresh">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="item-box-add" style="margin-top:20px;">
          <el-row style="margin-bottom:20px">
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <span style="padding:0px 0 14px 0;">仓储录入产品序列号</span>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-bottom:30px;">
            <div
              class="no-contet"
              style="text-align:center;margin-top:20px;"
              v-if="serailList.length===0"
            >暂无产品序列号</div>
            <el-col
              :span="6"
              v-for="(item,i) in serailList"
              :key="i"
              style="padding:10px 10px;border:1px solid #ebeef5"
            >
              <div class="grid-content bg-purple">{{ item }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { deepClone } from '@/util'

export default {
  data () {
    return {
      drawer: false,
      loadingTable: false,
      list: [], // 物流入库
      serailListDeepClone: [],
      serailList: [], // 产品序列号列表
      tempList: [], // 临时数组
      editable: true,
      isDragging: false,
      delayedDragging: false,
      bicId: '', // 传过来的参数,
      number: '',
      showCode: false
    }
  },
  methods: {
    // 报缺侧边栏初始化
    onInitialize (row) {
      this.list = [row]
      if (row.serialCode !== null) {
        this.serailList = row.serialCode.split(';')
      } else {
        this.serailList = []
      }
      this.serailListDeepClone = deepClone(this.serailList)
      // this.bicId = row.bicId
      //  点击跳转页面传过来的值
      this.drawer = true
    },
    // 型号跳产品详情页
    detailModel (row) {
      this.$router.push({
        path: '/product/productManage/productDetails',
        query: { id: row.proId }
      })
    },
    // 导出产品序列号
    toExport () {
      console.log('导出序列号')
    },
    // 查询
    onSearch () {
      this.serailList = deepClone(this.serailListDeepClone).filter(
        ele => ele.search(this.number) !== -1
      )
      if (this.serailList.length === 0) {
        this.showCode = false
      } else {
        this.showCode = true
      }
    },
    // 重置
    onRefresh () {
      this.serailList = deepClone(this.serailListDeepClone)
      this.number = ''
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 关闭
    onClose () {
      this.drawer = false
      this.list = []
      this.serailList = []
      // 清空序列号的缓存
      localStorage.removeItem('serailList')
    },
    // 关闭事件
    close () {
      this.drawer = false
      this.list = []
      this.serailList = []
    }
  }
}
</script>
<style  lang="scss" scoped>
h5,
h4 {
  text-align: center !important;
}
h5 {
  margin: 0px !important;
  font-size: 14px;
}
.join-inquiry-list-drawer {
  padding: 20px;
  color: #83878a;
  font-size: 14px !important;
  .join-inquier-list-crumbs {
    padding-left: 20px;
    font-size: 14px;
    span:first-child {
      color: #4e555b;
      padding-right: 10px;
    }
  }
  .join-inquier-list-product {
    padding: 30px 0 0 30px;
    .item-box-add {
      margin: 0 0 30px 0;
      .title-font-style {
        margin-bottom: 20px;
        font-weight: bold;
        font-size: 16px;
        color: #4e555b;
      }
      .serial_list {
        border: 1px solid #ebeef6;
        height: 500px;
        margin-top: 15px;
        width: 100%;
        display: flex;
        align-content: flex-start;
        justify-content: flex-start;
        flex-wrap: wrap;
        .serial_list_item {
          border-right: 1px solid #ebeef6;
          border-bottom: 1px solid #ebeef6;
          width: 16.5%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          &:nth-child(6n) {
            border-right: none;
          }
        }
      }
    }
  }
  .dialog-footer {
    width: 180px;
    margin: 30px auto;
    float: right;
  }
}
</style>
